import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthModalService } from '../../../services/auth-modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-verification',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-verification.component.html',
  styleUrl: './modal-verification.component.scss',
})
export class ModalVerificationComponent {
  private readonly modalService = inject(AuthModalService);
  private readonly router = inject(Router);

  codigo = '';
  captchaChecked = false;

  signIn(): void {
    this.modalService.close();
    this.router.navigate(['/attendees']);
  }
}
